import { render, staticRenderFns } from "./TabComposizione.vue?vue&type=template&id=44f43716&"
import script from "./TabComposizione.vue?vue&type=script&lang=js&"
export * from "./TabComposizione.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports